(function (global) {
  // Public reCAPTCHA v3 site key — must match server/includes/constants.js RECAPTCHA_SITE_KEY.
  var SITE_KEY = "6Lf70AgsAAAAALETpdvrFV4VSaIpBE-fh9nDKAXC";

  var loadPromise = null;

  function loadScript() {
    if (global.grecaptcha && typeof global.grecaptcha.execute === "function") {
      return Promise.resolve();
    }
    if (!loadPromise) {
      loadPromise = new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=" + encodeURIComponent(SITE_KEY);
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = function () {
          // Drop the dead tag and the memoized promise so the next call retries
          // with a fresh script instead of waiting on events that already fired.
          script.parentNode.removeChild(script);
          loadPromise = null;
          reject(new Error("recaptcha"));
        };
        document.head.appendChild(script);
      });
    }
    return loadPromise;
  }

  function executeRecaptcha(action) {
    action = action || "submit";
    return loadScript().then(function () {
      return new Promise(function (resolve, reject) {
        global.grecaptcha.ready(function () {
          global.grecaptcha.execute(SITE_KEY, { action: action }).then(resolve).catch(reject);
        });
      });
    });
  }

  // Do not prefetch Google's api.js. Loading it injects the floating
  // "protected by reCAPTCHA" badge, and this helper is included on home
  // (VIP) plus every contact-style form. The script is fetched the first
  // time a form actually submits.
  global.executeRecaptcha = executeRecaptcha;
})(window);
